import { EvtHeader } from "components/header";
import React from "react";
import KekaForm from "../form";

const CreateKeka = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Keka" />
      <div className="p-6 max-w-2xl">
        <KekaForm />
      </div>
    </div>
  );
};

export default CreateKeka;
